export default __webpack_public_path__ + "static/pic_tech-discovery-de602fd472e5cc39cf0e373472c88ca9.svg";